import React from 'react'
import { Typography, Hidden, Grid } from '@mui/material'
import { connect } from 'react-redux'
import AboutImage from '../../assets/images/about.jpeg'
import IntlMessages from '../../util/IntlMessages'
import { about } from '../../constants/data'
import Header from '../../components/header'
import useStyles from './styles'

function Abouts() {
    const classes = useStyles()

    const getContent = () => {
        return (
            <>
                <img src={AboutImage} alt="about" className={classes.img} />
                <Typography className={classes.content}>
                    {about}
                </Typography>
            </>
        )
    }

    return (
        <React.Fragment>
            <Header title={<IntlMessages id="abouts" />} />
            <Hidden smDown>
                <Grid container>
                    <Grid item xs={2} ms={2}></Grid>
                    <Grid item xs={8} ms={8}>{getContent()}</Grid>
                    <Grid item xs={2} ms={2}></Grid>
                </Grid>
            </Hidden>
            <Hidden smUp>
                {getContent()}
            </Hidden>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Abouts)
